import { render, staticRenderFns } from "./YourYagi.vue?vue&type=template&id=38c0d716"
import script from "./YourYagi.vue?vue&type=script&lang=js"
export * from "./YourYagi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports